import { StateSchema } from 'app/config/storeConfig/types';

export const getBase64string = (state: StateSchema): Nullable<string> => state.renderPDF.base64string;
